@if (!explanationName()) {
<h2 mat-dialog-title class="cut-long-text">Neue Erklärung</h2>
}
@else {
<h2 mat-dialog-title class="cut-long-text">
  Erklärung <span class="name">{{ explanationName() }}</span> bearbeiten
</h2>
}
<mat-divider></mat-divider>
<br />
<mat-dialog-content class="mat-typography">

  <mat-tab-group id="tab-group">
    <form [formGroup]="formGroup">
      <mat-tab label="Bearbeiten">
        <br />
        <div>
          <mat-form-field>
            <mat-label>Konsument</mat-label>
            <mat-select formControlName="consumerId">
              @for (consumer of consumers; track consumer) {
              <mat-option [value]="consumer.id">{{consumer.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <mat-label>Fach/Beruf</mat-label>
            <mat-select formControlName="subjectId">
              @for (competency of competencies; track competency) {
              <mat-option [value]="competency.treeId">{{competency.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput type="text" required placeholder="" formControlName="name" name="name" />
            <mat-error>{{ checkForNameErrors(formGroup.controls['name']) }}</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-label>Global gesperrt&nbsp;</mat-label>
          <mat-slide-toggle formControlName="copyRestricted"></mat-slide-toggle>
        </div>
        <br />
      </mat-tab>
      @if(consumerTabName()) {
      <mat-tab label="{{ consumerTabName() }}">
        <!-- Globale Metadaten -->
        <mat-card>
          <mat-card-header>
            <mat-card-title>Globale Metadaten</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <!-- <pixl-learnitem-metadata [mode]="LearnItemMetaDataComponentMode.GLOBAL" [formGroup]="formGroup"
              [learnObjectType]="'explanation'" [consumer]="data.getConsumer()" [approval]="approval()"
              [learnItem]="data"></pixl-learnitem-metadata> -->
          </mat-card-content>
        </mat-card>

        <!-- Lernobjekt Metadaten -->
        <mat-card>
          <mat-card-header>
            <mat-card-title>Lernobjekt Metadaten</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <br />
            <!-- <pixl-learnitem-metadata [mode]="LearnItemMetaDataComponentMode.LEARN_ITEM" [formGroup]="formGroup"
              [learnObjectType]="'explanation'" [consumer]="data.getConsumer()" [approval]="approval()"
              [learnItem]="data"></pixl-learnitem-metadata> -->
          </mat-card-content>
        </mat-card>

      </mat-tab>
      }
    </form>
  </mat-tab-group>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onCancel()">Abbruch</button>
  <button mat-raised-button (click)="onSave()"
    [disabled]="(!formGroup.valid || formGroup.controls['name'].value === '') || approval()">
    Speichern
  </button>
</mat-dialog-actions>